import Select from "./Select";
import { countries } from "../countries";

import type { RegisterProps } from "../data-types";

type Props = {
  [x: PropertyKey]: any;
  className?: string;
  name: string;
  hasErrors?: boolean;
  placeholderText: string;
  selectedValue?: string;
  registerProps: RegisterProps;
};

export default function SelectCountry({
  className = "",
  name,
  hasErrors = false,
  placeholderText,
  selectedValue,
  registerProps,
  ...rest
}: Props) {
  return (
    <Select
      className={className}
      data={countries}
      displayKey="name"
      hasErrors={hasErrors}
      placeholderText={placeholderText}
      selectedValue={selectedValue}
      valueKey="name"
      name={name}
      registerProps={registerProps}
      {...rest}
    />
  );
}
